import { render } from "./MessagesDisplay.vue?vue&type=template&id=196987f8"
import script from "./MessagesDisplay.vue?vue&type=script&lang=js"
export * from "./MessagesDisplay.vue?vue&type=script&lang=js"

import "./MessagesDisplay.vue?vue&type=style&index=0&id=196987f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__